import type { SelectElementProps } from 'react-hook-form-mui';
import { SelectElement } from 'react-hook-form-mui';

import { useAppTranslations } from '@treneo/shared/i18n';

import { translateErrorMessage } from '../constants/form-constants';

type Option = {
  id: string | number;
  label: string;
  description?: string;
};

type Props = SelectElementProps & {
  name: string;
  label: string;
  options: Option[];
  required?: boolean;
  fullWidth?: boolean;
};

export const SelectField = ({
  name,
  label,
  options,
  required = false,
  fullWidth = true,
  ...props
}: Readonly<Props>) => {
  const { t } = useAppTranslations();

  const parseError = (error: unknown) => {
    const message = translateErrorMessage(error);
    if (!message) {
      return '';
    }
    const translated = t(message);
    const hasTranslation = translated !== message;
    return hasTranslation ? translated : message;
  };

  return (
    <SelectElement
      {...props}
      name={name}
      label={label}
      options={options}
      required={required}
      fullWidth={fullWidth}
      parseError={parseError}
      slotProps={{ inputLabel: { shrink: true } }}
    />
  );
};
